const entity = {
  name: {
    singular: 'Banner',
    plural: 'Banners'
  },
  styles: {
    gridTemplateColumns: '20% 1fr'
  },
  collection: 'banners',
  tableHeaders: [
    { text: 'Nome', value: 'title' },
    { text: 'Código', value: 'slug' },
    { text: 'Actions', value: 'action', sortable: false }
  ],
  model: {
    title: '',
    items: [],
    slug: ''
  },
  schema: {
    groups: [
      {
        fields: [
          {
            type: 'input',
            inputType: 'text',
            label: 'Nome',
            model: 'title',
            required: true
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Código',
            model: 'slug',
            required: true
          }
        ]
      },
      {
        fields: [
          {
            type: 'galleryCards',
            label: 'Imagens',
            model: 'items',
            required: true
          }
        ]
      }
    ]
  }
}

export default [
  {
    path: '/banners',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../components/Crud/CrudList.vue')
  }, {
    path: '/banners/new',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../components/Crud/CrudForm.vue')
  }, {
    path: '/banners/:id',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../components/Crud/CrudForm.vue')
  }
]
